import { useRef, useState } from "react";
import axiosInstance from "../Services/Api";
import { useAuth } from "../Contexts/AuthContext";

const PixOutMobile = ({ showmodal, setShowModal }) => {
    const amount = useRef(null);
    const key = useRef(null);
    const { getUserdata } = useAuth();
    const [disabled, setDisabled] = useState(false);
    const [isAffiliate, setIsAffiliate] = useState(false); // Estado para verificar se é afiliado

    const handlePixOut = async (e) => {
        setDisabled(true);
        e.preventDefault();
        try {
            const endpoint = isAffiliate ? '/api/affiliateWithdrawal' : '/requestPayment'; // Endpoint baseado na seleção
            let response = await axiosInstance.post(endpoint, {
                pixkey: key.current.value,
                amount: amount.current.value,
            });

            if (response.data.detail === undefined) {
                alert(isAffiliate ? 'Saque solicitado aguarde a aprovação' : 'Saque efetuado com sucesso');
                key.current.value = '';
                amount.current.value = ''; // Corrigido para limpar o campo de valor
                await getUserdata();
                setShowModal(false);
            } else {
                alert(response.data.detail);
            }
            setDisabled(false);
        } catch (e) {
            setDisabled(false);
            if (e.status === 401) {
                window.localStorage.removeItem('token');
                window.location.href = '/#/login';
            }
        }
    };

    return (
        <div className={`fixed top-[20%] z-[999999] py-4 md:left-[150%] ${showmodal ? '' : 'hidden'} w-[300px] md:w-[734px] rounded-[12px] bg-[#1D1D1D]`}>
            <div className="w-full px-8 flex justify-between items-center border-b border-[#474747] pb-4">
                <h1 className="text-white">Adicionar Saldo Via Pix</h1>
                <svg onClick={() => { setShowModal(false); }} className="cursor-pointer" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.2638 11.4237C12.319 11.4789 12.3627 11.5444 12.3926 11.6164C12.4224 11.6885 12.4378 11.7658 12.4378 11.8438C12.4378 11.9218 12.4224 11.999 12.3926 12.0711C12.3627 12.1432 12.319 12.2087 12.2638 12.2639C12.2086 12.319 12.1431 12.3628 12.0711 12.3926C11.999 12.4225 11.9217 12.4379 11.8437 12.4379C11.7657 12.4379 11.6884 12.4225 11.6164 12.3926C11.5443 12.3628 11.4788 12.319 11.4236 12.2639L6.49996 7.33944L1.57629 12.2639C1.46488 12.3753 1.31377 12.4379 1.15621 12.4379C0.998654 12.4379 0.847547 12.3753 0.736136 12.2639C0.624724 12.1524 0.562134 12.0013 0.562134 11.8438C0.562134 11.6862 0.624724 11.5351 0.736136 11.4237L5.66055 6.50002L0.736136 1.57635C0.624724 1.46494 0.562134 1.31383 0.562134 1.15627C0.562134 0.998715 0.624724 0.847608 0.736136 0.736197C0.847547 0.624785 0.998654 0.562195 1.15621 0.562195C1.31377 0.562195 1.46488 0.624785 1.57629 0.736197L6.49996 5.66061L11.4236 0.736197C11.535 0.624785 11.6862 0.562195 11.8437 0.562195C12.0013 0.562195 12.1524 0.624785 12.2638 0.736197C12.3752 0.847608 12.4378 0.998715 12.4378 1.15627C12.4378 1.31383 12.3752 1.46494 12.2638 1.57635L7.33938 6.50002L12.2638 11.4237Z" fill="white" />
                </svg>
            </div>
            <form onSubmit={handlePixOut}>
                <div className="grid px-8 mt-2 gap-3 text-white grid-cols-2">
                    <div className="text-[#AEB9E1] text-[12px]">
                        <label>Nome do destinatário*</label>
                        <input placeholder="nome do destinatario" type="text" className="bg-[#313131] focus:outline-none text-white p-3 placeholder:text-[#727272] mt-2 h-[46px] w-full rounded-[10px]" />
                    </div>
                    <div className="text-[#AEB9E1] text-[12px]">
                        <label>Chave pix</label>
                        <input required ref={key} placeholder="chave pix" type="text" className="bg-[#313131] focus:outline-none text-white p-3 placeholder:text-[#727272] mt-2 h-[46px] w-full rounded-[10px]" />
                    </div>
                    <div className="text-[#AEB9E1] text-[12px]">
                        <label>Valor*</label>
                        <div className="flex items-center text-white gap-3">
                            R$
                            <input required ref={amount} placeholder="valor" type="number" className="bg-[#313131] focus:outline-none text-white p-3 placeholder:text-[#727272] mt-2 h-[46px] w-full rounded-[10px]" />
                        </div>
                    </div>
                    <div className="text-[#AEB9E1] text-[12px]">
                        <label>Descrição</label>
                        <input placeholder="descrição" type="text" className="bg-[#313131] focus:outline-none text-white p-3 placeholder:text-[#727272] mt-2 h-[46px] w-full rounded-[10px]" />
                    </div>
                    <div className="text-[#AEB9E1] text-[12px] col-span-2">
                        <label>Tipo de Saque</label>
                        <select onChange={(e) => setIsAffiliate(e.target.value === 'affiliate')} className="bg-[#313131] focus:outline-none text-white p-3 mt-2 h-[46px] w-full rounded-[10px]">
                            <option value="normal">Normal</option>
                            <option value="affiliate">Afiliado</option>
                        </select>
                    </div>
                </div>
                <div className="w-full mt-4 text-white px-8">
                    <button disabled={disabled} className="w-full rounded-[10px] bg-[#478DF8] p-3">{!disabled ? 'Transferir via Pix' : 'Transferindo'}</button>
                </div>
            </form>
        </div>
    );
};

export default PixOutMobile;